import {
    useAppKit,
    useAppKitAccount,
    useDisconnect,
} from '@reown/appkit/react';
import { useCallback, useMemo } from 'react';

import { shortenAddress } from '@/lib/utils';

export function useWallet() {
    const { open } = useAppKit();
    const { address, isConnected, status } = useAppKitAccount({
        namespace: 'eip155',
    });
    const { disconnect } = useDisconnect();

    const connect = useCallback(async () => {
        await open({
            view: 'Connect',
            namespace: 'eip155',
        });
    }, [open]);

    const openAccount = useCallback(async () => {
        await open({
            view: 'Account',
        });
    }, [open]);

    const openNetworks = useCallback(async () => {
        await open({
            view: 'Networks',
        });
    }, [open]);

    const disconnectWallet = useCallback(async () => {
        await disconnect({
            namespace: 'eip155',
        });
    }, [disconnect]);

    const shortAddress = useMemo(
        () => (address ? shortenAddress(address) : null),
        [address],
    );

    return {
        address,
        shortAddress,
        isConnected,
        status,
        connect,
        openAccount,
        openNetworks,
        disconnectWallet,
    };
}
